 <template>
    <section class="hero" style="background-color: #E3F2FD">
        <section id="banner">
            <div class="banner">
                <div class="container">
                    <div class="rows">
                    <div class="columns">
                        <div class="column">
                            <h1 class="title" style="font-family: 'Cinzel', serif; padding-top:15%">Tentang GERAKAN PANDAI</h1>
                            <div class="desc" style="font-family: 'Open Sans', sans-serif; font-size: 21px">
                                <p>Kegiatan yang dilaksanakan oleh <strong style="font-size:24px"> Bebras Indonesia</strong></p>
                                <p>dengan dukungan <strong style="font-size:24px">Google.org</strong></p>
                                <p>untuk menebarkan dan mengajarkan penguasaan Computational Thinking</p>
                                <p>kepada 2 juta siswa, melalui 22.000 guru berbagai mapel</p>
                                <p>di 22 daerah di Indonesia</p>
                            </div>
                        </div>
                        <div class="column">
                            <figure class="image is-5by4">
                            <img src="../assets/tentang-pandai2.jpg"
                            alt="carousel-1"
                            style="object-position: center; object-fit: contain;"/>
                        </figure>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div class="svg" style="margin-top: -250px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="0.5" d="M0,224L80,234.7C160,245,320,267,480,261.3C640,256,800,224,960,176C1120,128,1280,64,1360,32L1440,0L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
            <!-- <svg class="gelombang" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="0.8" d="M0,128L80,112C160,96,320,64,480,80C640,96,800,160,960,160C1120,160,1280,96,1360,64L1440,
            32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
            </svg> -->
            </div>
        </section>
        <section class="container-1056">
            <div>
                <b-carousel
                    v-if="carousel"
                    :pauseHover="false"
                    :pauseInfo="false"
                    :interval="10000"
                    :indicator="true"
                    :indicator-inside="true"
                    indicator-mode="hover"
                    indicator-position="is-bottom"
                    indicator-style="is-lines"
                >
                    <b-carousel-item>
                        <section class="hero is-large">
                        <div class="hero-head has-text-centered">
                            <figure class="image is-3by3">
                            <img src="../assets/bebrasBanner.jpg"
                                alt="carousel-1"
                                style="object-position: center; object-fit: cover;height:500px; filter: brightness(0.5)"/>
                            </figure>
                        </div>
                        </section>
                    </b-carousel-item>
                    <b-carousel-item>
                        <section class="hero is-large">
                        <div class="hero-head has-text-centered">
                            <figure class="image is-3by3">
                            <img
                                src="../assets/grow-with-google-bebras-id.jpg"
                                alt="carousel-1"
                                style="object-position: center; object-fit: cover; height:500px;filter: brightness(0.5)"
                            />
                            </figure>
                        </div>
                        </section>
                    </b-carousel-item>
                    <b-carousel-item>
                        <section class="hero">
                        <div class="hero-head has-text-centered">
                        
                            <figure class="image is-3by3">
                            <img
                                src="../assets/carousel5.png"
                                alt="carousel-1"
                                style="object-position: center; object-fit: cover; height:500px;filter: brightness(0.5)"
                            />
                            </figure>
                        </div>
                        </section>
                    </b-carousel-item>
                </b-carousel>
            </div>
        </section>
        <section>
            <div class="rows">
                <div class="columns">
                    <div class="column">
                        <figure class="image is-5by4">
                            <img src="../assets/desc-pandai.png"
                            alt="carousel-1"
                            style="object-position: center; object-fit: contain;"/>
                        </figure>
                    </div>
                    <div class="column">
                        <figure class="image is-5by4">
                            <img src="../assets/CT.png"
                            alt="carousel-1"
                            style="object-position: center; object-fit: contain;"/>
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="rows">
                <div class="columns">
                    <div class="column">
                        <figure class="image is-5by4">
                            <img src="../assets/2016-2017.png"
                            alt="carousel-1"
                            style="object-position: center; object-fit: contain;"/>
                        </figure>
                    </div>
                    <div class="column">
                        <h1 
                        style="padding-top: 40%; 
                        padding-left: 10%; 
                        font-weight: bold;
                        font-size: 30px">
                        BEBRAS CHALLENGE 2016 2017</h1>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="rows">
                <div class="columns">
                    <div class="column">
                        <h1 
                        style="padding-top: 40%; 
                        padding-left: 10%; 
                        font-weight: bold;
                        font-size: 30px">
                        BEBRAS CHALLENGE 2018 2019 2020</h1>
                    </div>
                    <div class="column">
                            <figure class="image is-5by4">
                            <img src="../assets/2018-2020.png"
                            alt="carousel-1"
                            style="object-position: center; object-fit: contain;"/>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="svg" style="margin-top: -250px">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="0.5" d="M0,224L80,234.7C160,245,320,267,480,261.3C640,256,800,224,960,176C1120,128,1280,64,1360,32L1440,0L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> -->
            <svg class="gelombang" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="0.8" d="M0,128L80,112C160,96,320,64,480,80C640,96,800,160,960,160C1120,160,1280,96,1360,64L1440,
            32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
            </svg>
            </div>
        </section>
    </section>
</template>

<script>
export default {
    data() {
        return {
            carousel: true
        }
    }

}
</script>

<style>

</style>